import { Col, Container, Row, Stack } from "react-bootstrap"

const HireCMSDeveloperContent = () => {  
    return (
        <Container className="hire-content-container">
            <Row>
                <Col>
                    <Stack className="hire-content-info">
                        <h2>
                            Hire Expert CMS Developers for Scalable Web Solutions
                        </h2>
                        <p>
                            Looking to build, customize, or scale your website using a powerful content management system? Our experienced CMS developers deliver robust, user-friendly, and SEO-optimized websites using platforms like WordPress, Magento, Shopify, Joomla, and Drupal.
                        </p>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Why Hire CMS Developers from Us?
                        </h2>
                        <ul>
                            <li>
                                <b>
                                    Multi-Platform Expertise
                                </b>
                                <p>
                                    Our developers specialize in WordPress, Magento, Shopify, Joomla, and Drupal — offering both theme and plugin/module development.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Custom Theme & Plugin Development
                                </b>
                                <p>
                                    We build fully custom themes and plugins tailored to your business needs while ensuring performance and compatibility.
                                </p>
                            </li>
                            <li>
                                <b>
                                    SEO & Speed Optimization
                                </b>
                                <p>
                                    We optimize CMS websites for performance, search engine visibility, and user engagement to boost your online presence.
                                </p>
                            </li>
                            <li>
                                <b>
                                    eCommerce CMS Solutions
                                </b>
                                <p>
                                    Get powerful, conversion-ready eCommerce stores using WooCommerce, Magento, or Shopify — complete with custom features and secure payment gateways.
                                </p>
                            </li>
                            <li>
                                <b>
                                    Flexible Engagement Models
                                </b>
                                <p>
                                    Hire CMS developers hourly, part-time, or full-time based on your project requirements and budget.
                                </p>
                            </li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Our CMS Development Services
                        </h2>
                        <ul>
                            <li>Custom CMS Website Development</li>
                            <li>Theme/Template Design & Integration</li>
                            <li>Plugin/Extension Development</li>
                            <li>CMS Migration & Upgrades</li>
                            <li>WooCommerce & Magento eCommerce Development</li>
                            <li>Ongoing Maintenance & Support</li>
                        </ul>
                    </Stack>
                    <Stack className="hire-content-info">
                        <h2>
                            Start Your CMS Project with Confidence
                        </h2>
                        <p>
                            Our CMS developers bring deep platform knowledge and a client-focused approach to ensure your website is functional, scalable, and easy to manage. Contact us today for a free consultation and quote.
                        </p>
                    </Stack>
                </Col>
            </Row>
        </Container>
    )
}

export default HireCMSDeveloperContent;
